// para el yo del futuro: Clandestino — parallax. mueve 0.38 para el movimiento de la imagen y 0.8 para el loguito
(function () {
  if (window.__clHomeParallax) return;
  window.__clHomeParallax = true;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;
  function pageTop(el) {
    var t = 0, n = el;
    while (n) { t += n.offsetTop || 0; n = n.offsetParent; }
    return t;
  }
  function init() {
    var hero = document.querySelector(".cl-hero");
    var heroSymbol = hero ? hero.querySelector(".cl-hero__art img") : null;
    if (hero) {
      hero.style.overflow = "hidden";
      hero.style.willChange = "background-position";
    }
    if (heroSymbol) heroSymbol.style.willChange = "transform";
    var movers = [].slice.call(
      document.querySelectorAll(".cl-bts img, .cl-featured .cl-product-card__media img, .cl-values img, .cl-impact img")
    );
    movers.forEach(function (img) {
      var wrap = img.parentElement;
      if (wrap) wrap.style.overflow = "hidden";
      img.style.willChange = "transform";
    });
    var titles = [].slice.call(
      document.querySelectorAll(".cl-bts__title, .cl-featured .cl-section-heading__title")
    );
    titles.forEach(function (t) { t.style.willChange = "transform"; });
    var raf = null;
    function frame() {
      raf = null;
      var y = window.scrollY || window.pageYOffset || 0;
      var vh = window.innerHeight || 800;
      if (hero) hero.style.backgroundPositionY = (y * 0.50).toFixed(1) + "px";
      if (heroSymbol) {
        var hp = -hero.getBoundingClientRect().top;
        heroSymbol.style.transform = "translate3d(0," + (hp * -0.08).toFixed(1) + "px,0)";
      }
      movers.forEach(function (img) {
        var center = pageTop(img) + (img.offsetHeight || 0) / 2;
        var rel = (y + vh / 2) - center;
        var dy = Math.max(-40, Math.min(40, rel * 0.05));
        img.style.transform = "translate3d(0," + dy.toFixed(1) + "px,0) scale(1.09)";
      });
      titles.forEach(function (t) {
        var center = pageTop(t) + (t.offsetHeight || 0) / 2;
        var rel = (y + vh / 2) - center;
        var dy = Math.max(-30, Math.min(30, rel * -0.03));
        t.style.transform = "translate3d(0," + dy.toFixed(1) + "px,0)";
      });
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    setInterval(onScroll, 500);
    frame();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();